import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className='container-fluid'>
            <div className="row">
                <div className="col-md-12 text-center p-3 bg-dark text-light mt-5">
                    <p>copyright @ SM's Body Buider</p>
                </div>
            </div>

        </div>
    );
};

export default Footer;